module.exports = __webpack_public_path__ + "assets/Flared Teeth selected.0f6cbc75214f4a76a84a3eaa46ce3f57.png";